import { render, staticRenderFns } from "./WannasornAdditionalCourseInfoPage.vue?vue&type=template&id=7b7ce633"
import script from "./WannasornAdditionalCourseInfoPage.vue?vue&type=script&lang=js"
export * from "./WannasornAdditionalCourseInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports